import api from "../api";

class PaymentsService {
  // Main payments index with activity overview
  async getActivePayments() {
    try {
      const response = await api.get("/payments/active");
      return response.data;
    } catch (error) {
      console.error("Error fetching active payments:", error);
      // Return mock data as fallback
      return {
        success: true,
        data: {
          payments: [
            {
              id: 1,
              rent_id: 1001,
              guardian_id: 66631,
              property_id: 2218,
              first_name: "John",
              last_name: "Smith",
              mobile: "07123456789",
              fee: 500.0,
              room: "Room 101",
              due_date: "2025-01-15",
              moved_in_date: "2024-01-15",
              oa_status: "O",
              payment_status: "Paid",
              rent_status: "Active",
              property: "12 Savage Road",
              notes: "Payment received on time",
              bank_account: "Main Account",
            },
            {
              id: 2,
              rent_id: 1002,
              guardian_id: 66632,
              property_id: 2219,
              first_name: "Jane",
              last_name: "Doe",
              mobile: "07987654321",
              fee: 450.0,
              room: "Room 102",
              due_date: "2025-01-10",
              moved_in_date: "2024-01-10",
              oa_status: "A",
              payment_status: "Overdue",
              rent_status: "Active",
              property: "15 Maple Street",
              notes: "Payment overdue",
              bank_account: "Secondary Account",
            },
            {
              id: 3,
              rent_id: 1003,
              guardian_id: 66633,
              property_id: 2220,
              first_name: "Mike",
              last_name: "Johnson",
              mobile: "07555123456",
              fee: 600.0,
              room: "Room 103",
              due_date: "2025-02-01",
              moved_in_date: "2024-02-01",
              oa_status: "O",
              payment_status: "To pay",
              rent_status: "Active",
              property: "8 Oak Avenue",
              notes: "Payment due soon",
              bank_account: "Main Account",
            },
          ],
          paymentsNotPaid: [
            {
              id: 2,
              rent_id: 1002,
              guardian_id: 66632,
              property_id: 2219,
              first_name: "Jane",
              last_name: "Doe",
              mobile: "07987654321",
              fee: 450.0,
              room: "Room 102",
              due_date: "2025-01-10",
              moved_in_date: "2024-01-10",
              oa_status: "A",
              payment_status: "Overdue",
              rent_status: "Active",
              property: "15 Maple Street",
              notes: "Payment overdue",
              bank_account: "Secondary Account",
            },
          ],
          paymentsPaid: [
            {
              id: 1,
              rent_id: 1001,
              guardian_id: 66631,
              property_id: 2218,
              first_name: "John",
              last_name: "Smith",
              mobile: "07123456789",
              fee: 500.0,
              room: "Room 101",
              due_date: "2025-01-15",
              moved_in_date: "2024-01-15",
              oa_status: "O",
              payment_status: "Paid",
              rent_status: "Active",
              property: "12 Savage Road",
              notes: "Payment received on time",
              bank_account: "Main Account",
            },
          ],
          paymentsToPay: [
            {
              id: 3,
              rent_id: 1003,
              guardian_id: 66633,
              property_id: 2220,
              first_name: "Mike",
              last_name: "Johnson",
              mobile: "07555123456",
              fee: 600.0,
              room: "Room 103",
              due_date: "2025-02-01",
              moved_in_date: "2024-02-01",
              oa_status: "O",
              payment_status: "To pay",
              rent_status: "Active",
              property: "8 Oak Avenue",
              notes: "Payment due soon",
              bank_account: "Main Account",
            },
          ],
          paymentsPlan: [],
          paymentsLegal: [],
          paymentsNoticeToQuit: [],
          totalPriceOfOccupiedRooms: 1550.0,
          totalPriceOfVacantRooms: 800.0,
        },
      };
    }
  }

  // Get payments for specific rent
  async getRentPayments(rentId) {
    try {
      const response = await api.get(`/payments/rent/${rentId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching rent payments:", error);
      throw error; // No mock data fallback - let component handle errors
    }
  }

  // Get payments for specific guardian
  async getGuardianPayments(guardianId) {
    console.log(
      "Guardian Payments Service: Starting request for guardian:",
      guardianId
    );

    try {
      console.log(
        "Attempting to fetch guardian payments from API for guardian:",
        guardianId
      );
      const response = await api.get(`/payments/guardian/${guardianId}`);
      console.log("API response received:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching guardian payments from API:", error);
      // No mock data fallback - throw error to component
      throw error;
    }
  }

  // Get guardian initial payments
  async getGuardianInitialPayments(guardianId) {
    try {
      const response = await api.get(
        `/payments/guardian/${guardianId}/initial`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching guardian initial payments:", error);
      throw error;
    }
  }

  // Get guardian key fee payments
  async getGuardianKeyFeePayments(guardianId) {
    try {
      const response = await api.get(
        `/payments/guardian/${guardianId}/key-fee`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching guardian key fee payments:", error);
      throw error;
    }
  }

  // Download guardian payments CSV
  async downloadGuardianPayments(guardianId) {
    try {
      const response = await api.get(
        `/payments/guardian/${guardianId}/download`,
        {
          responseType: "blob",
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error downloading guardian payments:", error);
      throw error;
    }
  }

  // Update guardian payments notes (using guardians changeField API)
  // Route: POST /api/guardians/change-field (guardianId in body, not URL)
  async updateGuardianPaymentsNotes(guardianId, notes) {
    try {
      const response = await api.post(`/guardians/change-field`, {
        guardianId: guardianId,
        field: "payments_notes",
        value: notes,
      });
      return response.data;
    } catch (error) {
      console.error("Error updating guardian payments notes:", error);
      throw error;
    }
  }

  // Get payments for specific property
  async getPropertyPayments(propertyId) {
    try {
      // Use the properties route instead of payments route to match the backend structure
      const response = await api.get(`/properties/${propertyId}/payments`);
      return response.data;
    } catch (error) {
      console.error("Error fetching property payments:", error);
      throw error; // Remove mock data fallback, let the component handle errors
    }
  }

  // Get create payment form data
  async getCreatePaymentForm(rentId) {
    try {
      const response = await api.get(`/payments/rent/${rentId}/create`);
      return response.data;
    } catch (error) {
      console.error("Error fetching create payment form:", error);
      throw error; // No mock data fallback - let component handle errors
    }
  }

  // Create new payment
  async createPayment(rentId, paymentData) {
    try {
      const response = await api.post(`/payments/rent/${rentId}`, paymentData);
      return response.data;
    } catch (error) {
      console.error("Error creating payment:", error);
      throw error;
    }
  }

  // Get edit payment form data
  async getEditPaymentForm(rentId, paymentId) {
    try {
      const response = await api.get(
        `/payments/rent/${rentId}/${paymentId}/edit`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching edit payment form:", error);
      throw error; // No mock data fallback - let component handle errors
    }
  }

  // Update payment
  async updatePayment(rentId, paymentId, paymentData) {
    try {
      // Add skipAuthLogout flag to prevent automatic logout on auth errors
      const response = await api.put(
        `/payments/rent/${rentId}/${paymentId}/edit`,
        paymentData,
        {
          skipAuthLogout: true,
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating payment:", error);
      // Don't rethrow - return error response instead to prevent logout
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to update payment",
      };
    }
  }

  // Delete payment (with rentId and paymentId)
  async deletePayment(paymentId) {
    try {
      // Use the simpler API route that only requires payment ID
      // Note: baseURL already includes /api, so don't add it again
      const response = await api.delete(`/payments/${paymentId}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting payment:", error);
      throw error;
    }
  }

  // Delete payment (original method with rentId)
  async deletePaymentWithRent(rentId, paymentId) {
    try {
      const response = await api.delete(
        `/payments/rent/${rentId}/${paymentId}/destroy`
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting payment with rent:", error);
      throw error;
    }
  }

  // Mark payment as paid - GET (load form data)
  async markPaymentAsPaid(rentId, paymentId) {
    try {
      const response = await api.get(
        `/payments/rent/${rentId}/${paymentId}/mark-as-paid`
      );
      return response.data;
    } catch (error) {
      console.error("Error marking payment as paid:", error);
      throw error;
    }
  }

  // Submit mark as paid - PUT (update payment)
  async submitMarkAsPaid(rentId, paymentId, formData) {
    try {
      const response = await api.put(
        `/payments/rent/${rentId}/${paymentId}/mark-as-paid`,
        formData
      );
      return response.data;
    } catch (error) {
      console.error("Error submitting mark as paid:", error);
      throw error;
    }
  }

  // Get mark as paid form data for initial payments - GET (load form data)
  // Laravel route: /rents/{rentId}/payments/mark-as-paid-initial/{paymentId}
  // Backend route: /api/initialpayments/rent/:rentId/mark-as-paid-initial/:id?
  async markPaymentAsPaidInitial(rentId, paymentId) {
    try {
      // Handle optional paymentId - if not provided, use endpoint without paymentId
      const url = paymentId
        ? `/initialpayments/rent/${rentId}/mark-as-paid-initial/${paymentId}`
        : `/initialpayments/rent/${rentId}/mark-as-paid-initial`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error("Error loading initial payment mark as paid form:", error);
      throw error;
    }
  }

  // Submit initial payment mark as paid - POST (update initial payment)
  // Laravel route: POST /payments/mark-as-paid-initial (form submission)
  // Backend route: /api/initialpayments/mark-as-paid-initial/submit
  async submitInitialMarkAsPaid(rentId, paymentId, formData) {
    try {
      const response = await api.post(
        `/initialpayments/mark-as-paid-initial/submit`,
        {
          rent_id: rentId,
          payment_id: paymentId,
          bank_account_id: formData.bank_account_id,
          amount_paid: formData.amount_paid,
          payment_date: formData.payment_date,
          notes: formData.notes || "",
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error submitting initial payment mark as paid:", error);
      throw error;
    }
  }

  // Send payment reminder
  async sendPaymentReminder(paymentId) {
    try {
      const response = await api.get(`/payments/payment/${paymentId}/reminder`);
      return response.data;
    } catch (error) {
      console.error("Error sending payment reminder:", error);
      throw error;
    }
  }

  // Send rent reminder
  async sendRentReminder(rentId) {
    try {
      const response = await api.get(`/payments/rent/${rentId}/reminder`);
      return response.data;
    } catch (error) {
      console.error("Error sending rent reminder:", error);
      throw error;
    }
  }

  // Get payments without due date
  async getPaymentsWithoutDueDate() {
    try {
      console.log("PaymentsService: Fetching payments without due date...");
      const response = await api.get("/payments/without-due-date");
      console.log("PaymentsService: Response received:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching payments without due date:", error);
      throw error; // No mock data fallback - let component handle errors
    }
  }

  // Export payments to CSV
  async exportPaymentsCSV() {
    try {
      const response = await api.get("/payments/export-clients", {
        responseType: "blob",
      });
      return response.data;
    } catch (error) {
      console.error("Error exporting payments CSV:", error);
      throw error;
    }
  }

  // Export payments to PDF
  async exportPaymentsPDF() {
    try {
      const response = await api.get("/payments/export-managers", {
        responseType: "blob",
      });
      return response.data;
    } catch (error) {
      console.error("Error exporting payments PDF:", error);
      throw error;
    }
  }

  // Initial Payments Methods

  // Get create initial payment form data
  async getCreateInitialPaymentForm(rentId) {
    try {
      const response = await api.get(`/payments/rent/${rentId}/create-initial`);
      return response.data;
    } catch (error) {
      console.error("Error fetching create initial payment form:", error);
      throw error; // No mock data fallback - let component handle errors
    }
  }

  // Create initial payment
  async createInitialPayment(rentId, paymentData) {
    try {
      const response = await api.post(
        `/payments/rent/${rentId}/store-initial`,
        paymentData
      );
      return response.data;
    } catch (error) {
      console.error("Error creating initial payment:", error);
      throw error;
    }
  }

  // Get edit initial payment form data
  async getEditInitialPaymentForm(rentId, paymentId) {
    try {
      const response = await api.get(
        `/initialpayments/rent/${rentId}/${paymentId}/edit-initial`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching edit initial payment form:", error);
      throw error; // No mock data fallback - let component handle errors
    }
  }

  // Update initial payment
  async updateInitialPayment(rentId, paymentId, paymentData) {
    try {
      const response = await api.put(
        `/initialpayments/rent/${rentId}/${paymentId}/edit-initial`,
        paymentData
      );
      return response.data;
    } catch (error) {
      console.error("Error updating initial payment:", error);
      throw error;
    }
  }

  // Delete initial payment
  async deleteInitialPayment(rentId, paymentId) {
    try {
      const response = await api.delete(
        `/initialpayments/rent/${rentId}/${paymentId}/destroy-initial`
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting initial payment:", error);
      throw error;
    }
  }

  // Mark initial payment as paid
  async markInitialPaymentAsPaid(rentId, paymentId) {
    try {
      const response = await api.get(
        `/payments/rent/${rentId}/mark-as-paid-initial/${paymentId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error marking initial payment as paid:", error);
      throw error;
    }
  }

  // Update payment
  async updatePayment(rentId, paymentId, paymentData) {
    try {
      // Add skipAuthLogout flag to prevent automatic logout on auth errors
      const response = await api.put(
        `/payments/rent/${rentId}/${paymentId}/edit`,
        paymentData,
        {
          skipAuthLogout: true,
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating payment:", error);
      // Don't rethrow - return error response instead to prevent logout
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to update payment",
      };
    }
  }

  // Mark payment as paid
  async markPaymentAsPaid(rentId, paymentId) {
    try {
      const response = await api.put(
        `/payments/rent/${rentId}/${paymentId}/mark-as-paid`
      );
      return response.data;
    } catch (error) {
      console.error("Error marking payment as paid:", error);
      throw error;
    }
  }

  // Remove payment completely with all related records
  async removePaymentCompletely(rentId, paymentId) {
    try {
      const response = await api.delete(
        `/payments/rent/${rentId}/${paymentId}/destroy`
      );
      return response.data;
    } catch (error) {
      console.error("Error removing payment completely:", error);
      throw error;
    }
  }

  // Send payment reminder (matching Laravel implementation)
  async sendPaymentReminder(paymentId) {
    try {
      const response = await api.get(`/payments/payment/${paymentId}/reminder`);
      return response.data;
    } catch (error) {
      console.error("Error sending payment reminder:", error);
      throw error;
    }
  }

  // Send rent reminder (matching Laravel implementation)
  async sendRentReminder(rentId) {
    try {
      const response = await api.get(`/payments/rent/${rentId}/reminder`);
      return response.data;
    } catch (error) {
      console.error("Error sending rent reminder:", error);
      throw error;
    }
  }

  // Mark payment as paid (matching Laravel implementation)
  async markPaymentAsPaid(rentId, paymentId) {
    try {
      const response = await api.put(
        `/payments/rent/${rentId}/${paymentId}/mark-as-paid`
      );
      return response.data;
    } catch (error) {
      console.error("Error marking payment as paid:", error);
      throw error;
    }
  }

  // Get payment create form data (matching Laravel implementation)
  async getPaymentCreateForm(rentId) {
    try {
      const response = await api.get(`/payments/rent/${rentId}/create`);
      console.log(
        "🔍 [PAYMENTS SERVICE] Payment create form API response:",
        response.data
      );
      return response.data;
    } catch (error) {
      console.error(
        "❌ [PAYMENTS SERVICE ERROR] Error fetching payment create form:",
        error
      );
      // No mock data fallback - let error propagate to component for proper error handling
      throw error;
    }
  }

  // Create new payment (matching Laravel implementation)
  async createPayment(rentId, paymentData) {
    try {
      // Add skipAuthLogout flag to prevent automatic logout on auth errors
      const response = await api.post(`/payments/rent/${rentId}`, paymentData, {
        skipAuthLogout: true,
      });
      return response.data;
    } catch (error) {
      console.error("Error creating payment:", error);
      // Don't rethrow - return error response instead to prevent logout
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to create payment",
      };
    }
  }

  // Mock data for payment create form
  getMockPaymentCreateData(rentId) {
    return {
      rent: {
        id: parseInt(rentId),
        date_start: "2024-04-17",
        date_end: "2030-01-31",
        status: "active",
        monthly_payment: 500.0,
        keys_provided: 2,
      },
      guardian: {
        id: 20047,
        unique_guardian_number: "LTFPX6U",
        fullName: "Raidom Gahnly",
        first_name: "Raidom",
        last_name: "Gahnly",
        email: "raidom@email.com",
        phone_number: "0221 277638",
        mobile_number: "07138758709",
        gender: "Male",
        date_of_birth: "14/05/1995",
        nationality: "British, UK",
        nhs_number: "365046970",
        next_of_kin: "Liz Gatley, 35 Telscroft Close, Corsham, Wiltshire",
        status: {
          id: 16,
          name: "Active",
          color: "#5cb85c",
        },
        hear_about: "-",
        image: null,
      },
      room: {
        id: 1,
        name: "Room 1",
        price: 500.0,
        key_number: 1,
      },
      property: {
        id: 353,
        property_id: "353C",
        name: "37 Plummer Road",
        status_text: "Full",
        address_1: "37 Plummer Road",
        postcode: "SW6 8HH",
        lease_start_date: "17/04/2025",
        lease_end_date: "31/01/2030",
        client_account: "Bank of Cyprus (3311)",
        client: {
          name: "Metropolitan Thames Valley MTVH",
        },
      },
      bankAccounts: {
        1: "Main Account",
        2: "Secondary Account",
        3: "Bank of Cyprus (3311)",
        4: "Barclays Business",
        5: "HSBC Current",
      },
      redirectUrl: `/rents/${rentId}/payments`,
    };
  }

  // Update all initial payments as paid
  async updateAllInitialPaymentsAsPaid(rentId, paymentIds) {
    try {
      const response = await api.put(
        `/payments/rent/${rentId}/update-all-initial`,
        { payment_ids: paymentIds }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating all initial payments as paid:", error);
      throw error;
    }
  }

  // Get payments without due date
  async getPaymentsWithoutDueDate() {
    try {
      const response = await api.get("/payments/without-due-date");
      return response.data;
    } catch (error) {
      console.error("Error fetching payments without due date:", error);

      // Return mock data with Laravel-compatible status values
      return {
        success: true,
        data: {
          payments: [
            {
              id: 1,
              rent_id: 1001,
              amount: 500.0,
              amount_formatted: "£500.00",
              amount_paid: 0.0,
              amount_paid_formatted: "£0.00",
              outstanding_amount: 500.0,
              outstanding_amount_formatted: "£500.00",
              status: 0, // Laravel status ID for "Not paid"
              status_text: "Not paid",
              status_label: "danger",
              due_date: null,
              payment_date: null,
              rent: {
                id: 1001,
                date_start: "2024-12-01T00:00:00.000Z",
                guardian: {
                  first_name: "John",
                  last_name: "Smith",
                  email: "john.smith@example.com",
                },
                room: {
                  name: "Room 101",
                  property: {
                    name: "12 Savage Road",
                  },
                },
              },
              bank_account: {
                name: "Main Account",
              },
            },
            {
              id: 2,
              rent_id: 1002,
              amount: 750.0,
              amount_formatted: "£750.00",
              amount_paid: 750.0,
              amount_paid_formatted: "£750.00",
              outstanding_amount: 0.0,
              outstanding_amount_formatted: "£0.00",
              status: 4, // Laravel status ID for "Plan" (Payment Plan)
              status_text: "Plan",
              status_label: "info",
              due_date: null,
              payment_date: null,
              rent: {
                id: 1002,
                date_start: "2024-11-15T00:00:00.000Z",
                guardian: {
                  first_name: "Jane",
                  last_name: "Doe",
                  email: "jane.doe@example.com",
                },
                room: {
                  name: "Room 205",
                  property: {
                    name: "15 Oak Street",
                  },
                },
              },
              bank_account: {
                name: "Secondary Account",
              },
            },
            {
              id: 3,
              rent_id: 1003,
              amount: 600.0,
              amount_formatted: "£600.00",
              amount_paid: 200.0,
              amount_paid_formatted: "£200.00",
              outstanding_amount: 400.0,
              outstanding_amount_formatted: "£400.00",
              status: 4, // Laravel status ID for "Plan" (Payment Plan)
              status_text: "Plan",
              status_label: "info",
              due_date: null,
              payment_date: null,
              rent: {
                id: 1003,
                date_start: "2024-10-01T00:00:00.000Z",
                guardian: {
                  first_name: "Michael",
                  last_name: "Johnson",
                  email: "michael.johnson@example.com",
                },
                room: {
                  name: "Room 303",
                  property: {
                    name: "25 Pine Avenue",
                  },
                },
              },
              bank_account: {
                name: "Third Account",
              },
            },
          ],
          total: 3,
          message: "Found 3 payments without due date",
        },
      };
    }
  }
}

export default new PaymentsService();
